import {useTranslation} from "@Translation/hooks/useTranslation";
import {multiModalTranslationKey} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import {RoutesOrganizedByTransportTypeType} from "@SearchResults/types/RoutesOrganizedByTransportType.type";
import {
    TicketsSoldByTransportTypeType
} from "@SearchResults/features/staticContent/types/TicketsSoldByTransportType.type";
import createMostPopularDataStats
    from "@SearchResults/features/staticContent/features/multiModal/functions/createMostPopularDataStats";

interface WhatIsMostPopularContentProps {
    departure: string,
    destination: string,
    transportTypes: TransportTypesType[],
    singleRoutes: RoutesOrganizedByTransportTypeType,
    ticketsSoldByTransportType: TicketsSoldByTransportTypeType
}

function WhatIsMostPopularContent(props: WhatIsMostPopularContentProps) {
    const {
        departure,
        destination,
        ticketsSoldByTransportType,
        singleRoutes,
        transportTypes,
    } = props

    const title = useTranslation(
        `${multiModalTranslationKey}.what_is_most_popular.title`,
        {departure, destination}
    )

    const description1 = useTranslation(
        `${multiModalTranslationKey}.what_is_most_popular.desc1`,
        {departure, destination}
    )
    const {
        preparedTicketsSoldByTransportType,
    } = createMostPopularDataStats(ticketsSoldByTransportType, transportTypes, singleRoutes)

    return (
        <>
            <TitleAndContent
                title={title}
                content={description1}
            />
            <ul>
                {preparedTicketsSoldByTransportType.map(({type, count}) => (
                    <li key={type}>
                        <b>
                            {type}
                            :
                        </b>
                        &nbsp;
                        {count}
                    </li>
                ))}
            </ul>
        </>
    )
}

export default WhatIsMostPopularContent